export function orderNumberPipe(input) {
  if (!input.startsWith('orders-')) return 'N/A';
  return input.replace('orders-', '');
}
